import { render, staticRenderFns } from "./create-group-file.vue?vue&type=template&id=72745c6c&scoped=true&"
import script from "./create-group-file.vue?vue&type=script&lang=js&"
export * from "./create-group-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72745c6c",
  null
  
)

export default component.exports